const CONTRACT_ID_QUERY_PARAM = 'ContractId';
const CONTRACT_PANEL_URL = '/profile/products';
const CONTRACT_PANEL_PRODUCT_ID_PARAM = 'idproducts';

type IndividualContract = {
  personalImage?: boolean;
}

type ContractData = {
  individual?: IndividualContract[];
}

export const hasCustomizablePicture = (contract: ContractData): boolean => {
  if (!contract) return false;

  const { individual } = contract;
  if (!individual || individual.length === 0) return false;

  return individual.some(c => c.personalImage === true);
};

export const getContractIdFromUrl = (paramName: string = CONTRACT_ID_QUERY_PARAM): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(paramName);
};

export const isIndividualContractChosen = (): boolean => !!getContractIdFromUrl();

export const shouldShowContractModal = (contractId: string | number | null, contract: ContractData): boolean => {
  if (contractId || !contract) return false;

  const { individual } = contract;
  return !!individual && individual.length > 0;
};

export const createContractPanelUrl = (productId: string | number, options: {
  panelUrl?: string;
  productIdParamName?: string;
} = {}): string => {
  const { panelUrl = CONTRACT_PANEL_URL, productIdParamName = CONTRACT_PANEL_PRODUCT_ID_PARAM } = options;
  return `${panelUrl}?${productIdParamName}=${productId}`;
};
